import { render, staticRenderFns } from "./tuipiao.vue?vue&type=template&id=3198ed6e&scoped=true&"
import script from "./tuipiao.vue?vue&type=script&lang=js&"
export * from "./tuipiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198ed6e",
  null
  
)

export default component.exports